import Authors, { AuthorFilers } from "../models/authors.model"
import { Author } from "../types/author"
import { useReducerAsState } from "./useReducerAsState";

interface State {
    error: string;
    loading: boolean;
    authors: Array<Author>;
    author: Author | null;
    totalAuthors: number;
}

const useAuthors = () => {
    const [state, setState] = useReducerAsState<State>({
        loading : false,
        error: "",
        author: null,
        authors: [],
        totalAuthors: 0
    })

    const { 
        loading,
        error,
        totalAuthors,
        author,
        authors
    } = state;

    const fetchAuthors = async (filters: AuthorFilers) => {
        setState({ loading: true, error: "" })
        const response = await Authors.getAll(filters)
        if(response.error){
            setState({
                loading: false,
                error: response.error,
                authors: []
            })
            return
        }

        setState({
            loading: false,
            error: "",
            authors: response.authors?.data,
            totalAuthors: response.total
        })
    }

    const findAuthor = async (authorId: number) => {
        if(!authorId) return;
        setState({ loading: true, error: "" })

        const response = await Authors.find(authorId)
        if(response.error){
            setState({
                loading: false,
                error: response.error,
                author: null
            })
            return
        }

        setState({
            loading: false,
            error: "",
            author: response.authors?.data[0],
        })
    }

    const saveAuthor = async (author: Author): Promise<boolean> => {
        if(!author) return false;
        setState({ loading: true, error: "" })

        const response = await Authors.save(author)
        if(response.error){
            setState({
                loading: false,
                error: response.error,
            })
            return false
        }

        setState({
            loading: false,
            error: "",
        })
        return true
    }

    const deleteAuthor = async (authorId: number): Promise<boolean> => {
        if(!authorId) return false;
        setState({ loading: true, error: "" })

        const response = await Authors.delete(authorId)
        if(response.error){
            setState({
                loading: false,
                error: response.error,
            })
            return false
        }

        setState({
            loading: false,
            error: "",
        })
        return true
    }

    return {
        fetchAuthors,
        findAuthor,
        saveAuthor,
        loading,
        error,
        author,
        totalAuthors,
        authors,
        deleteAuthor
    }
}

export default useAuthors